import _ from 'lodash'

export default {
  lowerBound(num, limit) {
    return num >= limit ? num : limit
  },
  /**
   * Fast UUID generator
  */
  guid() {
    function s4() {
      return Math.floor((1 + Math.random()) * 0x10000)
        .toString(16)
        .substring(1);
    }

    return s4() +
      s4() +
      '-' +
      s4() +
      '-' +
      s4() +
      '-' +
      s4() +
      '-' +
      s4() +
      s4() +
      s4();
  },
  /**
   * Quick object check - this is primarily used to tell
   * Objects from primitive values when we know the value
   * is a JSON-compliant type.
   */
  isObject(obj) {
    return obj !== null && typeof obj === 'object'
  },
  /**
   * Check if two values are loosely equal - that is,
   * if they are plain objects, do they have the same shape?
  */
  looseEqual(a, b) {
    // eslint-disable-next-line eqeqeq
    return a == b || (
      this.isObject(a) && this.isObject(b) ? JSON.stringify(a) === JSON.stringify(b) : false
    );
  },
  /**
   * Take a string and remove blank spaces, diacritics and put it lowerCase
   */
  toId(value) {
    value = _.trim(value)
    value = _.deburr(value)
    value = _.lowerCase(value)
    value = _.replace(value, new RegExp(' ', 'g'), '_')
    return value
  }
}



// WEBPACK FOOTER //
// ./scripts/services/Util.js